/**
 * The dashboard chunk (`DashboardShell.js`). One function, shared by the lazy
 * layouts in `index.js` and the login page's early fetch, so both ask webpack
 * for the same chunk and it downloads once.
 */
export const loadDashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "./DashboardShell");
